import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { MemberInvitationResponse } from './member-invitation-response';
import { API_BASE } from '../api-base.token';

const path = 'memberinvitations';

@Injectable({
  providedIn: 'root',
})
export class MemberInvitationsHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  get() {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.get<MemberInvitationResponse[]>(url);
  }
}
